import { ShieldCheck } from 'lucide-react';
import Navigation from '@/components/Navigation';
import Footer from '@/components/Footer';
import SafetyPanel from '@/components/SafetyPanel';

/* /safety — generic peace-of-mind page.  The reusable SafetyPanel does
 * the heavy lifting; here we only supply the site-level hero and a
 * gentle closing note. */

const HERO =
  'https://images.unsplash.com/photo-1687876790754-2a92a8f0686d?fm=jpg&q=70&w=2000&auto=format&fit=crop';

export default function SafetyPage() {
  return (
    <>
      <Navigation />
      <main
        data-testid="safety-page"
        className="bg-[var(--brand-parchment)] text-[var(--brand-forest)] pb-0"
      >
        {/* Hero */}
        <div className="relative h-[46svh] min-h-[340px] w-full overflow-hidden">
          <img
            src={HERO}
            alt="Warm sunrise over a Highland loch"
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div
            aria-hidden="true"
            className="absolute inset-0"
            style={{
              background:
                'linear-gradient(180deg, rgba(4,20,10,0.55) 0%, rgba(4,20,10,0.35) 40%, rgba(4,20,10,0.85) 100%)',
            }}
          />
          <div className="absolute inset-x-0 bottom-0 max-w-4xl mx-auto px-6 lg:px-10 pb-10 text-[var(--brand-parchment)]">
            <span className="font-eyebrow !text-[var(--brand-gold)] inline-flex items-center gap-2">
              <ShieldCheck size={14} /> Safety &amp; Emergency
            </span>
            <h1 className="mt-3 font-display text-5xl sm:text-6xl leading-[1.02] [text-shadow:0_2px_20px_rgba(0,0,0,0.55)]">
              Peace of mind in the{' '}
              <span className="italic text-[var(--brand-gold)]">Highlands.</span>
            </h1>
          </div>
        </div>

        {/* The reusable panel — no `site` prop → generic guidance */}
        <SafetyPanel />

        {/* Gentle closing note */}
        <section className="max-w-3xl mx-auto px-6 lg:px-10 mt-14 pb-24">
          <div className="hairline opacity-40" />
          <p className="mt-6 text-sm text-[var(--brand-muted)] leading-relaxed">
            None of this is meant to worry you. The hills are for enjoying, and
            they&rsquo;re at their best when you&rsquo;ve done the boring bits
            beforehand. Ride well, look after each other, and come home to tell
            the tale.
          </p>
        </section>
      </main>
      <Footer />
    </>
  );
}
